




































































import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import {
  AiMonthReportSetting,
  DefaultAiMonthReportSetting,
  AiMonthReportAiSet,
} from "#/model/admin/index";
import { ListPromptTemplate } from "@/views/aimonthreport/types";
import RulesMixin from "#/mixins/rulesMixin";

@Component({
  components: {
    AppAuthButton,
  },
})
/**
 * 月次報告書自動作成管理 プロンプトテンプレート一覧
 */
export default class AiMonthReportPromptTemplateList extends Mixins(
  AxiosMixin,
  UtilMixin,
  RulesMixin
) {
  /** 変数 */

  /** 月次報告書AI自動作成設定 */
  private setting: AiMonthReportSetting = DefaultAiMonthReportSetting();

  /** フィルター用キーワード */
  private searchKeyword = "";

  /** 1ページあたりの表示件数 */
  private itemPerPage = 25;

  /** 表の現在のページ数 */
  private pageNo = 1;

  /** プロンプトテンプレート一覧 */
  private promptTemplates: ListPromptTemplate[] = [];

  /** データテーブル用ヘッダー */
  private headers = [
    {
      text: "",
      value: "actions",
      sortable: false,
      align: "end",
      width: "200px",
    },
    {
      text: "テンプレート名",
      align: "start",
      value: "name",
      width: "180px",
      filterable: true,
      sortable: false,
    },
    {
      text: "コメント",
      align: "start",
      value: "comment",
      width: "180px",
      filterable: true,
      sortable: false,
    },
    {
      text: "メーカー名",
      align: "start",
      value: "llm_type_name",
      filterable: false,
      width: "120px",
    },
    {
      text: "モデル名",
      align: "start",
      value: "model_name",
      filterable: false,
      width: "180px",
    },
    {
      text: "最終更新者",
      align: "start",
      value: "editor_admin_name",
      filterable: false,
      sortable: false,
      width: "140px",
    },
    {
      text: "最終更新日時",
      align: "start",
      value: "updated_at",
      filterable: false,
      width: "140px",
    },
  ];

  /** AI選択リスト */
  private aiSets: AiMonthReportAiSet[] = [];

  /** 関数 */

  created() {
    this.fetch();
    this.fetchSetting();
  }

  /** 取得 */
  private fetch() {
    this.postJsonCheck(
      window.base_url + "/api/admin/aimonthreport/prompts/get",
      {},
      async (res) => {
        this.promptTemplates = res.data.prompt_templates;
      }
    );
  }

  /** 自動作成設定取得 */
  private fetchSetting() {
    this.postJsonCheck(
      window.base_url + "/api/admin/aimonthreport/setting/get",
      {},
      async (res) => {
        this.setting = res.data.ai_month_report_setting;
        this.aiSets = res.data.ai_sets;
      }
    );
  }

  /** 表のページ変更 */
  private changePage(pageNo: number) {
    this.pageNo = pageNo;
  }

  /** 編集画面へ遷移 */
  private moveEditPage(id: number, isCopy = false) {
    this.$router.push({
      path: `/ai-monthreport/prompt/edit/${id}`,
      query: { mode: isCopy ? "copy" : "edit" },
    });
  }

  /** 稼働中プロンプトテンプレートをハイライト */
  private workingItemRowBackground(item: ListPromptTemplate) {
    return this.checkWorkingItem(item.id) ? "ibow-admin-selected-item-row" : "";
  }

  /** 稼働中プロンプトテンプレートチェック */
  private checkWorkingItem(id: number) {
    return (
      this.aiSets.findIndex(
        (aiSet) =>
          aiSet.is_valid == 1 &&
          (id == aiSet.prompt_template_id ||
            id == aiSet.modify_main_expression_prompt_template_id ||
            id == aiSet.betten_prompt_template_id ||
            id == aiSet.modify_betten_expression_prompt_template_id)
      ) !== -1
    );
  }

  /** 表示設定画面に戻る */
  private moveToViewSetPage() {
    this.$router.push({ path: "/ai-monthreport/viewset" });
  }
}
